import React from 'react'
import styles from "styles/pages/Pages.module.scss";

export const RenderPuesto = (puesto, rowPosition, hanndleSelectId, id) => (
        <div 
            key={puesto.id} 
            className={`${styles.containerUnit} ${puesto.id === id && styles.select} ${styles.puestoColor}`} 
            style={{ gridColumn: '5', gridRow: rowPosition }}
            onClick={() => hanndleSelectId(puesto.id)}
        >
            <div className={styles.containerUnitData}>
                <span className={styles.unitText}>{puesto.name}</span>
            </div>
        </div>
    );
